"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Erc20Transfer = void 0;
var common_core_1 = require("@moralisweb3/common-core");
var EvmAddress_1 = require("../EvmAddress");
var EvmChain_1 = require("../EvmChain");
/**
 * The Erc20Transfer is a representation of an Erc20 token transfer.
 *
 * @category DataType
 */
var Erc20Transfer = /** @class */ (function () {
    function Erc20Transfer(data) {
        this._data = Erc20Transfer.parse(data);
    }
    /**
     * Create a new instance of Erc20Transfer from any valid input
     * @param data - the Erc20Transferish type
     * @example
     * ```
     * const transfer = Erc20Transfer.create(data);
     *```
     */
    Erc20Transfer.create = function (data) {
        if (data instanceof Erc20Transfer) {
            return data;
        }
        return new Erc20Transfer(data);
    };
    /**
     * Check the equality between two Erc20 transfers
     * @param dataA - The first transfer to compare
     * @param dataB - The second transfer to compare
     * @example Erc20Transfer.equals(dataA, dataB)
     * @returns true if the transfers are equal, false otherwise
     */
    Erc20Transfer.equals = function (dataA, dataB) {
        var tokenA = Erc20Transfer.create(dataA);
        var tokenB = Erc20Transfer.create(dataB);
        return JSON.stringify(tokenA.toJSON()) === JSON.stringify(tokenB.toJSON());
    };
    /**
     * Checks the equality of the current trnasfer with another erc20 trnasfer
     * @param data - the transfer to compare with
     * @example transfer.equals(data)
     * @returns true if the transfers are equal, false otherwise
     */
    Erc20Transfer.prototype.equals = function (data) {
        return Erc20Transfer.equals(this, data);
    };
    /**
     * @returns a JSON represention of the transfer.
     * @example transfer.toJSON()
     */
    Erc20Transfer.prototype.toJSON = function () {
        var data = this._data;
        return __assign(__assign({}, data), { chain: data.chain.format(), address: data.address.format(), blockNumber: data.blockNumber.toString(), toAddress: data.toAddress.format(), fromAddress: data.fromAddress.format(), value: data.value.toString() });
    };
    /**
     * @returns a JSON represention of the transfer.
     * @example transfer.format()
     */
    Erc20Transfer.prototype.format = function () {
        return this.toJSON();
    };
    Object.defineProperty(Erc20Transfer.prototype, "result", {
        /**
         * @returns all the data without casting it to JSON.
         * @example transfer.result
         */
        get: function () {
            return this._data;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Transfer.prototype, "address", {
        /**
         * @returns the address of the tranfer
         * @example transfer.address // EvmAddress
         */
        get: function () {
            return this._data.address;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Transfer.prototype, "blockHash", {
        /**
         * @returns the block hash of the tranfer
         * @example transfer.blockHash // "0x0372c302e3c52e8f2e15d155e2c545e6d802e479236564af052759253b20fd86"
         */
        get: function () {
            return this._data.blockHash;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Transfer.prototype, "blockNumber", {
        /**
         * @returns the block number of the tranfer
         * @example transfer.blockNumber // BigNumber
         */
        get: function () {
            return this._data.blockNumber;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Transfer.prototype, "blockTimestamp", {
        /**
         * @returns the block timestamp of the tranfer
         * @example transfer.blockTimestamp // Date
         */
        get: function () {
            return this._data.blockTimestamp;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Transfer.prototype, "chain", {
        /**
         * @returns the chain of the tranfer
         * @example transfer.chain // EvmChain
         */
        get: function () {
            return this._data.chain;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Transfer.prototype, "fromAddress", {
        /**
         * @returns the from address of the tranfer
         * @example transfer.fromAddress // EvmAddress
         */
        get: function () {
            return this._data.fromAddress;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Transfer.prototype, "toAddress", {
        /**
         * @returns the to address of the tranfer
         * @example transfer.toAddress // EvmAddress
         */
        get: function () {
            return this._data.toAddress;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Transfer.prototype, "transactionHash", {
        /**
         * @returns the transaction hash of the tranfer
         * @example transfer.transactionHash // "0x0372c302e3c52e8f2e15d155e2c545e6d802e479236564af052759253b20fd86"
         */
        get: function () {
            return this._data.transactionHash;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Transfer.prototype, "value", {
        /**
         * @returns the value of the tranfer
         * @example transfer.value // BigNumber
         */
        get: function () {
            return this._data.value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Transfer.prototype, "transactionIndex", {
        /**
         * @returns the transactionIndex of the tranfer
         * @example transfer.transactionIndex // 3
         */
        get: function () {
            return this._data.transactionIndex;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Transfer.prototype, "logIndex", {
        /**
         * @returns the logIndex of the tranfer
         * @example transfer.logIndex // 2
         */
        get: function () {
            return this._data.logIndex;
        },
        enumerable: false,
        configurable: true
    });
    Erc20Transfer.parse = function (data) { return (__assign(__assign({}, data), { chain: EvmChain_1.EvmChain.create(data.chain), address: EvmAddress_1.EvmAddress.create(data.address), blockTimestamp: (0, common_core_1.dateInputToDate)(data.blockTimestamp), blockNumber: common_core_1.BigNumber.create(data.blockNumber), toAddress: EvmAddress_1.EvmAddress.create(data.toAddress), fromAddress: EvmAddress_1.EvmAddress.create(data.fromAddress), value: common_core_1.BigNumber.create(data.value) })); };
    return Erc20Transfer;
}());
exports.Erc20Transfer = Erc20Transfer;
//# sourceMappingURL=Erc20Transfer.js.map